/**
 * Permission API client
 * Requirements: 15.1-15.9 - Permission management
 */
import { createAuthenticatedClient } from '../../../shared/api/axiosClient';
import type {
  PermissionLevel,
  SetPermissionDTO,
  PermissionHistoryResponse,
  EmployeesByPermissionResponse,
} from '../types/permission.types';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

let apiClient: ReturnType<typeof createAuthenticatedClient> | null = null;

const getApiClient = () => {
  if (!apiClient) {
    apiClient = createAuthenticatedClient(API_BASE_URL, () => {
      window.location.href = '/login';
    });
  }
  return apiClient;
};

export const permissionApi = {
  /**
   * Set employee permission level
   */
  async setPermissionLevel(employeeId: string, data: SetPermissionDTO): Promise<void> {
    const client = getApiClient();
    await client.put(`/employees/${employeeId}/permission`, data);
  },

  /**
   * Get permission change history for an employee
   */
  async getPermissionHistory(employeeId: string): Promise<PermissionHistoryResponse> {
    const client = getApiClient();
    const response = await client.get<PermissionHistoryResponse>(`/employees/${employeeId}/permission-history`);
    return response.data;
  },

  /**
   * Get employees by permission level
   */
  async getEmployeesByPermission(level: PermissionLevel): Promise<EmployeesByPermissionResponse> {
    const client = getApiClient();
    const response = await client.get<EmployeesByPermissionResponse>(`/employees/by-permission/${level}`);
    return response.data;
  },
};
